<template>
  <sdPageHeader :title="$t('pages.tasks.title')"> </sdPageHeader>
  <Main>
    <sdCards>
      <a-row :gutter="16">
        <a-col :span="4">
          <label> {{ $t('common.type') }} </label>
          <a-select :placeholder="$t('common.choose')" style="width: 100%" v-model:value="filter.type">
            <a-select-option :value="null">
              {{ $t('common.choose') }}
            </a-select-option>
            <a-select-option value="app">
              {{ $t('pages.tasks.app') }}
            </a-select-option>
            <a-select-option value="order">
              {{ $t('pages.tasks.order') }}
            </a-select-option>
             <a-select-option value="demo">
              Demo
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="4">
          <label> {{ $t('common.status') }} </label>
          <a-select :placeholder="$t('common.choose')" style="width: 100%" v-model:value="filter.task_status">
            <a-select-option :value="null">
              {{ $t('common.choose') }}
            </a-select-option>
            <a-select-option :value="1">
              {{ $t('pages.tasks.completed') }}
            </a-select-option>
            <a-select-option :value="0">
              {{ $t('pages.tasks.waiting') }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="1">
          <label> &nbsp;</label>
          <sdButton size="small" type="info" @click="onClickFilter">
            {{ $t('common.filter') }}
          </sdButton>
        </a-col>
      </a-row>
      <br />
      <br />
      <div v-if="isLoading" class="spin">
        <a-spin />
      </div>
      <div v-else>
        <a-table
          :pagination="{
            pageSize: this.filter.pageSize,
            showSizeChanger: true,
            total: this.filter.total,
            current: this.filter.current,
          }"
          @change="onTableChange"
          :columns="columns"
          :data-source="records"
          size="small"
        >
          <template #is_completed="{ record }">
            <a-tag color="success" v-if="record.is_completed == 1">
              <template #icon>
                <check-circle-outlined />
              </template>
              {{ $t('pages.tasks.completed') }}
            </a-tag>
            <a-tag color="warning" v-if="record.is_completed == 0">
              <template #icon>
                <clock-circle-outlined />
              </template>
              {{ $t('pages.tasks.waiting') }}
            </a-tag>
          </template>
          <template #action="{ record }">
            <a-space>
              <a-tooltip placement="top">
                <template #title>
                  <span>İşlem Detayı</span>
                </template>
                <router-link
                  :to="
                    record.type == 'app'
                      ? '/applications/detail/' + record.app_id + '/review'
                      : '/orders/detail/' + record.order_id
                  "
                >
                  <a-button type="primary">
                    <template #icon> <sdFeatherIcons type="link-2" style="color: white" /> </template>
                  </a-button>
                </router-link>
              </a-tooltip>
              <a-tooltip placement="top" v-if="record.is_completed == 1">
                <template #title>
                  <span> {{ $t('pages.tasks.wait-do-it') }}</span>
                </template>
                <a-button @click="toggleComplete(record.key, 0)" type="danger">
                  <template #icon> <sdFeatherIcons type="x" /> </template>
                </a-button>
              </a-tooltip>
              <a-tooltip placement="top" v-else>
                <template #title>
                  <span> {{ $t('pages.tasks.complete') }}</span>
                </template>
                <a-button @click="toggleComplete(record.key, 1)" type="success">
                  <template #icon> <sdFeatherIcons type="check" /> </template>
                </a-button>
              </a-tooltip>
            </a-space>
          </template>
        </a-table>
      </div>
    </sdCards>
  </Main>
</template>

<script>
import { Main } from '@/view/styled';
import { dateToTr } from '@/utility/helper';

import {
  SyncOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons-vue';

export default {
  name: 'ViewPage',
  components: {
    Main,
    SyncOutlined,
    ClockCircleOutlined,
    CheckCircleOutlined,
    ExclamationCircleOutlined,
  },
  data() {
    return {
      isLoading: true,
      search: '',
      rowSelection: null,
      filter: {
        task_status: null,
        type: null,
        current: 1,
        pageSize: 10,
        total: null,
        order_id : null
      },
      records: [],
      columns: [
        {
          key: 0,
          title: '#',
          dataIndex: 'id',
          key: 'id',
          width: 80,
        },
        {
          key: 0,
          title: this.$t('pages.tasks.app-name'),
          dataIndex: 'title',
          key: 'title',
        },
        {
          key: 0,
          title: this.$t('common.type'),
          dataIndex: 'type_text',
          key: 'type_text',
        },
        {
          title: this.$t('common.description'),
          dataIndex: 'description',
          key: 'description',
        },
        {
          title: this.$t('common.status'),
          dataIndex: 'is_completed',
          key: 'is_completed',
          slots: { customRender: 'is_completed' },
        },
        {
          key: 0,
          title: this.$t('common.update-date'),
          dataIndex: 'updated_at',
          key: 'updated_at',
          ellipsis: true,
        },
        {
          key: 0,
          title: this.$t('common.create-date'),
          dataIndex: 'created_at',
          key: 'created_at',
          ellipsis: true,
        },
        {
          title: this.$t('common.action'),
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
          width: 150,
        },
      ],
    };
  },
  methods: {
    get() {
      this.isLoading = true;
      this.records = [];
      this.$appAxios.post(this.$endpoints.tasks_get, this.filter).then((resp) => {
        if (resp.data.status) {
          var _this = this;
          _this.filter.total = resp.data.data.count;
          resp.data.data.records.forEach(function (item, index) {
            _this.records.push({
              key: index,
              id: item.id,
              app_id: item.app_id,
              order_id: item.order_id,
              type: item.type,
              type_text: _this.$t('pages.tasks.' + item.type),
              description: item.description,
              title: item.app_title,
              is_completed: item.is_completed,
              updated_at: dateToTr(item.updated_at),
              created_at: dateToTr(item.created_at),
            });
          });
          this.isLoading = false;
        }
      });
    },
    toggleComplete(key, is_completed) {
      const formData = {
        task_id: this.records[key].id,
        is_completed: is_completed,
      };
      this.$appAxios.post(this.$endpoints.tasks_complete_toggle, formData).then((resp) => {
        if (resp.data.status) {
          this.records[key].is_completed = is_completed;
          this.$message.success(this.$t('common.success-message'));
        } else {
          this.$message.error(this.$t('common.error-message'));
        }
      });
    },
    onClickFilter() {
      this.filter.current = 1;
      this.get();
    },
    onTableChange(e) {
      this.filter.current = this.isFilterNew ? 1 : e.current;
      this.filter.pageSize = e.pageSize;
      this.get();
    },
  },
  created() {
    if (typeof this.$route.query.type != 'undefined'){
      this.filter.type = this.$route.query.type;
    }
    if (typeof this.$route.query.order_id != 'undefined'){
      this.filter.order_id = this.$route.query.order_id;
    }

    this.get();
  },
};
</script>
<style>
.ant-btn-success {
  color: #fff;
  background-color: #198754;
  border-color: #198754;
}
.ant-btn-success:hover {
  color: #fff;
  background-color: #157347;
  border-color: #146c43;
}
</style>